import React, { FC, useState } from 'react';
import { Dialog, DialogBody, DialogFooter, DialogHeader } from '@gravity-ui/uikit';
import { VideosService } from '../../../../api/api-services/videos-service/videosService';
import { toastError, toastSuccess } from '../../../../libs/toasts/toasts';
import { VideoInfo } from '../../../../types/video/VideoInfo';
import { vzhikLogger } from '../../../../libs/vzhik-logger/VzhikLogger';
import { UploadSDK } from '@yandex-int/video-upload-sdk';
import { commonT, dialogsT, toastsT } from '../../../../i18n';

type DeleteVideoDialogProps = {
    isOpen: boolean;
    videoInfo: VideoInfo;
    isMobile?: boolean;
    onClose: () => void;
    onDelete: () => void;
};

export const DeleteVideoDialog: FC<DeleteVideoDialogProps> = ({
    isOpen,
    videoInfo,
    isMobile,
    onClose,
    onDelete,
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const buttonWidth = isMobile ? 'auto' : 'max';

    const handleDeleteDialogApply = async () => {
        try {
            setLoading(true);
            await UploadSDK.removeUpload(videoInfo.tusd_url);
            await VideosService.deleteVideoDocument(videoInfo.video_id);
            onDelete();
            toastSuccess.open(toastsT('videoDeleted'));
        } catch (e) {
            console.error(e);
            toastError.open(toastsT('deleteFailed'));
            vzhikLogger.logError({
                message: 'Не удалось удалить видео',
                type: 'server',
                additional: {
                    error: e,
                },
            });
        } finally {
            onClose();
            setLoading(false);
        }
    };

    return (
        <Dialog
            className={
                isMobile
                    ? 'page-videolist-dialog page-videolist-dialog--mobile'
                    : 'page-videolist-dialog'
            }
            open={isOpen}
            aria-labelledby="app-confirmation-dialog-title"
            onClose={onClose}
            onEnterKeyDown={handleDeleteDialogApply}
            size="s"
        >
            <DialogHeader
                caption={dialogsT('deleteVideoTitle')}
                id="app-confirmation-dialog-title"
            />
            <DialogBody>{dialogsT('deleteVideoWarning', { title: videoInfo.title })}</DialogBody>
            <DialogFooter
                onClickButtonApply={handleDeleteDialogApply}
                onClickButtonCancel={onClose}
                textButtonApply={commonT('delete')}
                textButtonCancel={commonT('cancel')}
                propsButtonApply={{
                    loading: loading,
                    width: buttonWidth,
                }}
                propsButtonCancel={{
                    disabled: loading,
                    width: buttonWidth,
                }}
            />
        </Dialog>
    );
};
